<template>
  <div class="pages">

    <div class="as">
      <img src="../static/images/main/banner.png" width="100%"/>
      <!--<mu-tabs :value.sync="active" color="#F2F2F2" indicator-color="#ffffff" @change="getIndex" v-if="reFresh">-->
      <!--<mu-tab v-for="day in weeks">{{ day.data }} <br> <em>{{ day.name }}</em></mu-tab>-->
      <!--</mu-tabs>-->
      <div class="tabs">
        <div class="dayInfo" v-for="(day,i) in weeks" @click="changeActive(day.disable,i)">
          <div :class="[{'disableTab':day.disable}]">
            <div :class="[{'tab':true},{'activeTab':i == active}]">
              周{{ day.name.substring(2, 3) }}
            </div>
            <div class="dayDate">
              <span>{{ day.dayDate }}</span><br>
              {{ day.monthDate }}月
            </div>
          </div>
        </div>
      </div>

      <div class="classSelect">
        <div :class="[{'classTime':true},{'activeClass':timeSelect == ''}]" @click="changeTime('')">全部课程</div>
        <div :class="[{'classTime':true},{'activeClass':timeSelect == 1}]" @click="changeTime(1)">上午</div>
        <div :class="[{'classTime':true},{'activeClass':timeSelect == 2}]" @click="changeTime(2)">下午</div>
        <div :class="[{'classTime':true},{'activeClass':timeSelect == 3}]" @click="changeTime(3)">晚上</div>
        <span class="sum">
<!--          {{ today }} -->
        预约名额剩余
        <em class="black">{{ num }}</em>
        人
        </span>
      </div>

    </div>
    <div class="context">
      <ul class="list">
        <li v-for="l in list">
          <!--左边课程名和消耗课时-->
          <div class="title">
            <h5><span class="lessons">{{ l.ClassName }}</span></h5>
            <span>{{ l.ConsumeHour }} 课时</span>
          </div>
          <!--中间课程时间-->
          <div class="lessonTime">
            <span>{{ l.BeginStr }}</span>
            <span> - </span>
            <span>{{ l.EndStr }}</span>
          </div>
          <!--右边预约控制-->
          <div class="orderLimit">
            <div class="orderRemind">预约 <span> {{ l.remain }} </span>/ <em>{{ l.OrderToplimit }}</em></div>
            <!-- 可匹配课程 -->
            <div v-if="l.IsAllowSelect > 0">
              <mu-button class="appointBtn" v-if="l.remain > 0 && l.OrderId == 0 && l.WxOrder != 0"
                         @click="appointNow(l)">
                预约
              </mu-button>
              <mu-button class="appointBtn" v-if="l.remain == 0 && l.OrderId == 0" @click="isFulled">满员
              </mu-button>
              <mu-button class="appointBtn" v-if="l.OrderId != 0" @click="isAppointed(l)">已约</mu-button>
              <mu-button class="appointBtn disableBtn" v-if="l.WxOrder == 0 && l.OrderId == 0" @click="isDisable">预约
              </mu-button>
            </div>
            <!-- 不可匹配课程 -->
            <div v-else>
              <mu-button class="appointBtn disableBtn" @click="isDisable" v-if="l.OrderId == 0">预约</mu-button>
            </div>
          </div>

        </li>

        <div class="tips" v-if="list == ''">
          <p style="text-align: center">
            暂无可预约的课程
          </p>
        </div>
      </ul>
      <mu-avatar color="rgb(231, 82, 150)" @click.native="goPage('lesson')">
        <mu-icon value="reorder"></mu-icon>
      </mu-avatar>
    </div>
    <bottomTab :curTab="thisTab"></bottomTab>
    <div class="doalog">
      <mu-dialog title="预约课程" width="600" max-width="80%" :esc-press-close="false" :overlay-close="false"
                 :open.sync="openAlert">
        <p>
          是否预约 课程：{{ dialog.ClassName }} ，时间：{{ dialog.BeginStr }} - {{ dialog.EndStr }}
          <br>
        </p>
        <mu-button slot="actions" flat color="primary" @click="closeAlertDialog">取消</mu-button>
        <mu-button slot="actions" flat color="primary" @click="confirmAppoint">确定</mu-button>
      </mu-dialog>
    </div>
    <alert ref="alertPart"></alert>
  </div>
</template>

<script>
import axios from 'axios';
import bottomTab from '../components/bottomTab'
import {
  CanOrderSchoolTimeTableListQuery,
  OderAddByVipUser,
  OderCancelByVipUser,
  QueryNextWeek
} from '../api/getApiRes.js'

import alert from '../components/alert'

let qs = require('qs');
import Global from '../Global.js'

export default {
  data() {
    return {
      num: 0,
      thisTab: '预约课程',
      active: 0,
      timeSelect: '',
      sum: 0,
      HaveDays: 0,
      openAlert: false,
      reFresh: true,
      list: [],
      weeks: [],
      today: '',
      dialog: {
        id: '',
        name: '',
        timeLong: '',
      },
    }
  },
  mounted() {
    this.getQueryNextWeek();
    // this.alertInfo(document.body.clientWidth);
    // this.alertInfo( window.screen.height);
  },
  watch: {
    '$route'(to) {
      if (to.name == 'appoint') {
        this.getList();
      }
    },
    'active'(to) {
      this.getList();
    }
  },
  activated() {
    this.active = 0;
    this.reFresh = false;
    this.$nextTick(() => {
      this.reFresh = true;
      this.getQueryNextWeek();
    });

  },
  methods: {
    changeActive(disable, i) {
      if (disable) {
        return;
      }
      this.active = i;
    },
    changeTime(i) {
      this.timeSelect = i;
      this.getList();
    },
    getIndex(val) {
      console.log(val);
    },
    getQueryNextWeek() {
      let that = this;
      let param = {
        token: localStorage.token,
        shopId: this.$route.query.shopId,
      };
      let postdata = qs.stringify(param);
      this.weeks = [];
      QueryNextWeek(postdata).then(res => {
        let json = res;
        if (json.Code == 0) {
          this.HaveDays = json.Rs;
          this.getFurtherDays(this.HaveDays);
        } else {
          that.list = [];
          that.$message.error(json.Memo);
        }
      })
    },
    alertInfo(info) {
      this.$refs.alertPart.openSimpleDialog(info);
    },
    goPage(url) {
      this.$router.push({
        path: '/' + url, query: {
          shopId: this.$route.query.shopId
        }
      });
    },
    // 获取未来7天的
    getFurtherDays(HaveDays) {
      let now = new Date();
      let nowTime = now.getTime();
      let oneDayTime = 24 * 60 * 60 * 1000;
      let days = '';
      let item = [];
      let month = 0;
      let day = 0;
      let disable = false;
      this.weeks = [];
      for (let i = 0; i < 7; i++) {//共显示7天,没课表的灰掉
        days = new Date(nowTime + (i) * oneDayTime);//显示周日
        month = days.getMonth() + 1;
        day = days.getDate();
        month = month < 10 ? '0' + month : month;
        day = day < 10 ? '0' + day : day;
        if (i >= HaveDays) {
          disable = true;
        }
        item = {
          name: this.numberToWeek(days.getDay()),
          data: days.getMonth() + 1 + '月' + days.getDate() + '日',
          orderDate: days.getFullYear() + '-' + month + '-' + day,
          day: this.numberToWeek(days.getDay()),
          monthDate: days.getMonth() + 1,
          dayDate: days.getDate(),
          disable: disable
        };
        this.weeks.push(item);
      }
      this.today = this.weeks[0].name;
      this.getList();
    },
    numberToWeek(val) {
      switch (parseInt(val)) {
        case 1:
          return '星期一';
          break;
        case 2:
          return '星期二';
          break;
        case 3:
          return '星期三';
          break;
        case 4:
          return '星期四';
          break;
        case 5:
          return '星期五';
          break;
        case 6:
          return '星期六';
          break;
        case 0:
          return '星期天';
          break;
      }
    },
    confirmAppoint() {
      let that = this;
      that.openAlert = false;
      let param = {
        token: localStorage.token,
        stdId: that.dialog.StdId
      };
      let postdata = qs.stringify(param);
      OderAddByVipUser(postdata).then(res => {
        let json = res;
        if (json.Code == 0) {
          that.alertInfo('已成功预约', 'success');
          that.getList();
        } else {
          that.alertInfo(json.Memo + ' 错误码：' + json.Code);
        }
      })
    },
    closeAlertDialog() {
      this.openAlert = false;
    },
    appointNow(row) {
      this.dialog = row;
      this.openAlert = true;
    },
    isFulled() {
      let that = this;
      that.$alert('当前课程满员，请选择其他课程或其他时间预约', '提示', {
        okLabel: '知道了'
      }).then(() => {
        that.getList();
      });
    },
    isAppointed(row) {
      let that = this;
      this.$confirm('是否取消前课程预约？', '提示', {
        type: 'warning'
      }).then(({result}) => {
        if (result) {
          let param = {
            token: localStorage.token,
            orderId: row.OrderId,
          };
          let postdata = qs.stringify(param);
          OderCancelByVipUser(postdata).then(res => {
            let json = res;
            if (json.Code == 0) {
              that.alertInfo('当前课程已取消预约', 'success');
              that.getList();
            } else {
              that.alertInfo(json.Memo + ' 错误码：' + json.Code);
            }
          })
        } else {
          this.alertInfo('点击了取消');
        }
      });
    },
    isDisable(row) {
      this.alertInfo('课程不可预约，请选择其他课程或其他时间预约', 'info');
    },
    getList() {
      let that = this;
      this.today = this.weeks[this.active].name;
      let curDay = this.weeks[this.active].orderDate;
      let param = {
        token: localStorage.token,
        orderDate: curDay,
        shopId: this.$route.query.shopId,
        orderTimeType: this.timeSelect
      };
      let postdata = qs.stringify(param);
      that.list = [];
      that.num = 0;
      CanOrderSchoolTimeTableListQuery(postdata).then(res => {
        let json = res;
        // json = JSON.parse('{"Code":0,"Memo":"执行成功","Rs":[{"StdId":17834,"Basic":null,"StbId":182,"CurrentDate":"2021-12-30","WeekDay":4,"BeginTime":"2021-12-30T18:10:00+08:00","EndTime":"2021-12-30T19:10:00+08:00","BeginStr":"18:10","EndStr":"19:10","ClassId":7,"OrderToplimit":4,"ConsumeHour":2,"LessonIndex":14,"WxVisible":1,"WxOrder":1,"FinishClass":0,"SvId":0,"SvName":"","TId":0,"OId":0,"HrClassOn":0,"HrClassOff":0,"DpId":0,"PkNum":0,"ClassType":0,"Base":{"CreatedAt":"2021-12-26T16:43:27.008264+08:00","CreateUser":13,"UpdatedAt":"2021-12-27T20:37:46.458004+08:00","LasteditUser":93},"ClassName":"功能课","ClassColor":"#8ABFF7","OrderCount":0,"OrderId":0,"IsAllowSelect":7},{"StdId":17836,"Basic":null,"StbId":182,"CurrentDate":"2021-12-30","WeekDay":4,"BeginTime":"2021-12-30T18:40:00+08:00","EndTime":"2021-12-30T19:40:00+08:00","BeginStr":"18:40","EndStr":"19:40","ClassId":8,"OrderToplimit":1,"ConsumeHour":4,"LessonIndex":15,"WxVisible":1,"WxOrder":1,"FinishClass":0,"SvId":0,"SvName":"","TId":0,"OId":0,"HrClassOn":0,"HrClassOff":0,"DpId":0,"PkNum":0,"ClassType":0,"Base":{"CreatedAt":"2021-12-26T16:43:27.008889+08:00","CreateUser":13,"UpdatedAt":"2021-12-27T20:37:46.458644+08:00","LasteditUser":93},"ClassName":"个人训练","ClassColor":"#FCC66C","OrderCount":0,"OrderId":0,"IsAllowSelect":8},{"StdId":17835,"Basic":null,"StbId":182,"CurrentDate":"2021-12-30","WeekDay":4,"BeginTime":"2021-12-30T18:40:00+08:00","EndTime":"2021-12-30T19:40:00+08:00","BeginStr":"18:40","EndStr":"19:40","ClassId":36,"OrderToplimit":4,"ConsumeHour":2,"LessonIndex":16,"WxVisible":1,"WxOrder":1,"FinishClass":0,"SvId":0,"SvName":"","TId":0,"OId":0,"HrClassOn":0,"HrClassOff":0,"DpId":0,"PkNum":0,"ClassType":0,"Base":{"CreatedAt":"2021-12-26T16:43:27.008563+08:00","CreateUser":13,"UpdatedAt":"2021-12-27T20:37:46.459221+08:00","LasteditUser":93},"ClassName":"神经控制","ClassColor":"#7AA3E6","OrderCount":0,"OrderId":0,"IsAllowSelect":36},{"StdId":17837,"Basic":null,"StbId":182,"CurrentDate":"2021-12-30","WeekDay":4,"BeginTime":"2021-12-30T19:20:00+08:00","EndTime":"2021-12-30T20:20:00+08:00","BeginStr":"19:20","EndStr":"20:20","ClassId":7,"OrderToplimit":4,"ConsumeHour":2,"LessonIndex":17,"WxVisible":1,"WxOrder":1,"FinishClass":0,"SvId":0,"SvName":"","TId":0,"OId":0,"HrClassOn":0,"HrClassOff":0,"DpId":0,"PkNum":0,"ClassType":0,"Base":{"CreatedAt":"2021-12-26T16:43:27.009212+08:00","CreateUser":13,"UpdatedAt":"2021-12-27T20:37:46.459791+08:00","LasteditUser":93},"ClassName":"功能课","ClassColor":"#8ABFF7","OrderCount":0,"OrderId":0,"IsAllowSelect":7},{"StdId":17840,"Basic":null,"StbId":182,"CurrentDate":"2021-12-30","WeekDay":4,"BeginTime":"2021-12-30T19:50:00+08:00","EndTime":"2021-12-30T20:50:00+08:00","BeginStr":"19:50","EndStr":"20:50","ClassId":33,"OrderToplimit":4,"ConsumeHour":2,"LessonIndex":18,"WxVisible":1,"WxOrder":1,"FinishClass":0,"SvId":0,"SvName":"","TId":0,"OId":0,"HrClassOn":0,"HrClassOff":0,"DpId":0,"PkNum":0,"ClassType":0,"Base":{"CreatedAt":"2021-12-26T16:43:27.010131+08:00","CreateUser":13,"UpdatedAt":"2021-12-27T20:37:46.460378+08:00","LasteditUser":93},"ClassName":"灵敏训练","ClassColor":"#B38CAB","OrderCount":0,"OrderId":0,"IsAllowSelect":0},{"StdId":17841,"Basic":null,"StbId":182,"CurrentDate":"2021-12-30","WeekDay":4,"BeginTime":"2021-12-30T19:50:00+08:00","EndTime":"2021-12-30T20:50:00+08:00","BeginStr":"19:50","EndStr":"20:50","ClassId":43,"OrderToplimit":4,"ConsumeHour":2,"LessonIndex":19,"WxVisible":1,"WxOrder":1,"FinishClass":0,"SvId":0,"SvName":"","TId":0,"OId":0,"HrClassOn":0,"HrClassOff":0,"DpId":0,"PkNum":0,"ClassType":0,"Base":{"CreatedAt":"2021-12-26T16:43:27.010421+08:00","CreateUser":13,"UpdatedAt":"2021-12-27T20:37:46.460993+08:00","LasteditUser":93},"ClassName":"提高（复合）课","ClassColor":"#E2B5FA","OrderCount":2,"OrderId":0,"IsAllowSelect":0},{"StdId":17839,"Basic":null,"StbId":182,"CurrentDate":"2021-12-30","WeekDay":4,"BeginTime":"2021-12-30T19:50:00+08:00","EndTime":"2021-12-30T21:00:00+08:00","BeginStr":"19:50","EndStr":"21:00","ClassId":29,"OrderToplimit":5,"ConsumeHour":3,"LessonIndex":20,"WxVisible":1,"WxOrder":1,"FinishClass":0,"SvId":0,"SvName":"","TId":0,"OId":0,"HrClassOn":0,"HrClassOff":0,"DpId":0,"PkNum":0,"ClassType":0,"Base":{"CreatedAt":"2021-12-26T16:43:27.009821+08:00","CreateUser":13,"UpdatedAt":"2021-12-27T20:37:46.461609+08:00","LasteditUser":93},"ClassName":"特训（力量）课","ClassColor":"#1DD5D5","OrderCount":3,"OrderId":0,"IsAllowSelect":0}]}');
        //Todo 结果集模拟，记得注释掉
        if (json.Code == 0) {
          that.list = json.Rs;
          if (that.list) {
            // 计算剩余
            that.num = 0;
            that.list.map(function (item) {
              item.remain = parseInt(item.OrderToplimit) - parseInt(item.OrderCount);
              that.num = that.num + item.remain
            })
          }
        } else {
          that.alertInfo(json.Memo + ' 错误码：' + json.Code);
        }
      })
    },
  },
  components: {
    bottomTab, alert
  }
}
</script>

<style scoped>
.pages {
  overflow: hidden;
  display: block;
  margin: 0 auto;
}

/*mu-header*/
.mu-primary-color {
  line-height: 60px;
  height: 60px;
  background: url("../static/images/comm/headerBg.png") top center no-repeat;
  background-size: 100%;
}

/deep/ .mu-appbar-left {
  padding-top: 15px;
}

/deep/ .material-icons {
  color: #fff;
}

/deep/ .mu-appbar-title {
  text-align: center;
}

/deep/ .mu-tabs {
  /*display: flex;*/
  /*width: 414px;*/
  overflow-x: scroll;
  overflow-y: hidden;
  /*display:inline;*/
  /*float: left;*/
}

/deep/ .mu-tab {
  width: 85px;
  min-width: 85px;
  float: left;
  height: 51px;
  margin-right: 6px;
}

/*/deep/ .mu-tab:nth-child(5) {*/
/*    margin-right: 0px;*/
/*}*/

/deep/ .mu-tab-wrapper {
  height: 51px;
  background: #f4f4f4;
  color: #363636;
  box-shadow: 1px 0px 6px rgba(0, 0, 0, 0.16);
  border-radius: 8px 8px 0px 0px;
  font-size: 14px;
}

/deep/ .mu-tab-active .mu-tab-wrapper {
  height: 56px;
  border-radius: 8px 8px 0px 0px;
  background: #ffffff;
  box-shadow: 1px 0px 6px rgba(0, 0, 0, 0.16);
  color: #000;
}

/deep/ .mu-tab-wrapper em {
  font-size: 12px;
}

.classSelect {
  margin-top: 10px;
}

.classSelect .classTime {
  height: 28px;
  padding-left: 7px;
  padding-right: 7px;
  line-height: 26px;
  text-align: center;
  float: left;
  border-radius: 5px;
  display: block;
  background: #f4f4f4;
  margin-left: 5px;
  margin-bottom: 15px;
}

.sum {
  float: right;
  margin-right: 20px;
  background: #fff;
  line-height: 25px;
  font-family: "PingFang SC";
  font-weight: 300;
  font-size: 14px;
  color: #909090;
}

.black {
  color: #000;
}

.green {
  color: #37CB00;
}

.red {
  color: #F8847F;
}

.list {
  width: 100%;
  overflow: hidden;
  display: block;
  margin: 30px auto 0;
  padding-bottom: 30px;
}

.list li {
  width: 100%;
  height: 70px;
}

.list .dotContainer {
  width: 50px;
  float: left;
  height: 60px;
  padding-left: 22px;
  padding-top: 10px;
}

.dotContainer .dot {
  width: 12px;
  height: 12px;
  background: #37cb00;
  border-radius: 250px;
  float: left;
}

.cubes {
  width: 12px;
  height: 12px;
  background: #f8847f;
  float: left;
}

.tri {
  width: 12px;
  height: 12px;
  background: url("../static/images/appoint/tri.png") top center no-repeat;
  background-size: 100% 100%;
  float: left;
}

.x {
  width: 12px;
  height: 12px;
  background: url("../static/images/appoint/x.png") top center no-repeat;
  background-size: 100% 100%;
  float: left;
}

.list li {
  background: #ffffff;
  width: 90%;
  border-radius: 7px;
  margin: 0 auto 10px;
}

.list li .title {
  /*width: 90px;*/
  width: 27%;
  height: 50px;
  float: left;
  margin-left: 20px;
  margin-top: 5px;
}


li .title span.lessons {
  width: 180px;
  display: block;
  padding-left: 5px;
  float: left;
  text-align: left;
  margin-top: 5px;
  color: #3B3B3B;
  font-size: 16px;
}

li .title h5 {
  width: 100%;
  display: block;
  margin: 5px auto;
  font-size: 14px;
  text-align: left;
  color: #3b3b3b;
}

li .title span {
  width: 90%;
  overflow: hidden;
  display: block;
  margin: 0 auto;
  font-weight: normal;
  font-size: 12px;
  text-align: left;
  color: #909090;
}

.lessonTime {
  height: 60px;
  float: left;
  margin-top: 10px;
  margin-left: 13%;
}

.lessonTime span{
  text-align: center;
  display: block;
  color: #E75296;
  font-size: 12px;
}
.orderLimit {
  float: right;
  margin-right: 5%;
  text-align: center;
  height: 65px;
}

.orderRemind {
  font-weight: 300;
  margin-top: 10px;
  font-size: 12px;
}

.orderRemind span {
  color: #E75296;
}

.appointBtn {
  width: 76px;
  height: 27px;
  border-radius: 14px;
  background: #E75296;
  margin-top: 4px;
  color: white;
  font-family: "PingFang SC";
  float: right;
  font-weight: normal;
  font-size: 14px;
}

.disableBtn {
  /*border: 1px solid #C9C9C9;*/
  background: #f4f4f4;
  color: #ffffff;
}

/deep/ .mu-tabs-center {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

/deep/ .mu-tabs-center::-webkit-scrollbar {
  display: none;
}

/deep/ .mu-modal-inner {
  width: 90%;
  float: left;
}

/deep/ .mu-tab-link-highlight {
  display: none !important;
}


/deep/ .mu-avatar {
  position: fixed;
  bottom: 9%;
  float: left;
  left: 1%;
}

.context {
  position: absolute;
  left: 0;
  right: 0;
  top: 30%;
  margin-top: 35px;
  bottom: 0;
  overflow-y: scroll;
  padding-bottom: 50px;
}

.as {
  position: fixed;
  width: 100%;
  overflow: hidden;
  display: block;
  margin: 0 auto;
  z-index: 222;
  background: #FFFFFF;
}

/deep/ .mu-raised-button {
  box-shadow: none;
}

.tabs {
  width: 100%;
  padding-left: 5px;
  height: 100px;
  background: #FFFFFF;
  /*justify-content: space-between;Todo若有问题可注释回来*/
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: scroll;
  display: flex;
}

.tab {
  font-size: 12px;
  background: #F4F4F4;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  text-decoration: none;
  border: none;
  outline: none;
  color: inherit;
  position: relative;
  -webkit-transition: all .45s cubic-bezier(.445, .05, .55, .95);
  transition: all .45s cubic-bezier(.445, .05, .55, .95);
  width: 54px;
  margin-right: 3px;
  margin-left: 3px;
  float: left;
  height: 22px;
  cursor: pointer;
  line-height: 24px;
  text-align: center;
  margin-top: 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.tab.activeTab {
  color: #fff;
  background-color: #E75296;
  color: hsla(0, 0%, 100%, .7);
}

.dayInfo {
  max-width: 57px;
}

.dayInfo .disableTab {
  color: #D6D6D6;
}

.dayDate {
  float: left;
  width: 54px;
  height: 60px;
  background: #f4f4f4;
  font-size: 12px;
  margin-left: 3px;
  margin-top: 1px;
  margin-right: 3px;
  text-align: center;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.classSelect .activeClass {
  background-color: #E75296;
  color: white;
}

.dayDate span {
  font-size: 22px;
}

/*响应式调整*/
@media only screen and (max-width: 320px) {
  .list .dotContainer {
    width: 20px;
    padding-left: 5px;
  }

  .list li .title {
    width: 30%;
  }

  .list li .current {
    width: 29%;
  }

  .context {
    top: 227px;
  }
}

@media (min-width: 321px) and (max-width: 344px) {
  .list li .current {
    width: 28%;
  }

  .context {
    top: 227px;
  }
}

@media (min-width: 345px) and (max-width: 360px) {
  .list li .current {
    width: 30%;
  }

  .context {
    top: 230px;
  }
}

@media (min-width: 361px) and (max-width: 375px) {
  .list li .current {
    width: 30%;
  }

  .context {
    top: 230px;
  }
}

@media (min-width: 376px) and (max-width: 396px) {
  .list li .current {
    width: 30%;
  }

  .context {
    top: 230px;
  }
}

@media (min-width: 397px) and (max-width: 414px) {
  .list li .current {
    width: 30%;
  }

  .context {
    top: 230px;
  }
}

@media (min-width: 415px) and (max-width: 480px) {
  .list li .current {
    width: 30%;
  }

  .context {
    top: 230px;
  }
}

@media (min-width: 481px) and (max-width: 640px) {
  .context {
    position: fixed;
    /*top: 230px;*/
  }
}

@media (min-width: 641px) and (max-width: 2481px) {
  .context {
    position: fixed;
    top: 38%;
    /*top: 230px;*/
  }
}

@media (min-width: 2482px) and (max-width: 3841px) {
  .context {
    position: fixed;
    top: 60%;
    /*top: 230px;*/
  }
}
</style>
